import { mapDeviceAuthenticationStateFromSysApi } from '@shure/shared/angular/data-access/device-authentication';
import { DeviceAuthentication, DeviceAuthenticationState } from '@shure/shared/angular/data-access/system-api/models';

import { AuthenticationFeatureFragment } from '../graphql/generated/cloud-sys-api';

export function mapDeviceAuthenticationFromSysApi(
	sysApiAuthentication: AuthenticationFeatureFragment['authentication'] | undefined | null
): DeviceAuthentication {
	const authentication: DeviceAuthentication = {
		authenticated: false,
		state: DeviceAuthenticationState.InitializedNotSet,
		enabled: false,
		readonlyModeSelected: false,
		enabledButNotAuthenticated: false
	};

	if (sysApiAuthentication?.credentials && sysApiAuthentication.credentials.length === 1) {
		const state = mapDeviceAuthenticationStateFromSysApi(sysApiAuthentication.credentials[0].credentialsState);
		authentication.state = state;
		authentication.enabled = state === DeviceAuthenticationState.Set;
	}

	return authentication;
}
